/**
 * スライド
 */

import $ from 'jquery';
import { TweenMax } from 'gsap';

const tm = TweenMax;

class Slide {
	constructor(id, $root, btn = { prev: $([]), next: $([]) }) {
		this.id = id;
		this.$root = $root;
		this.$list = this.$root.find('.selected-slide__list');
		this.$items = $([]);
		this.$delete_btn = $([]);
		this.$prev_btn = btn.prev;
		this.$next_btn = btn.next;
		this.touches = { startX: 0, moveX: 0, endX: 0, currentX: 0 };
		this.count = 0;
		this.maxcount = 0;
		this.distance = 0;
		this.items_width = 0;
		this.set = new Set();
		this.addListeners();
		this.update();
	}

	addListeners() {
		$(window).on('resize', $.proxy(this.onResize, this));
		this.$root.on('touchstart touchmove touchend', $.proxy(this.onTouch, this));
		this.$prev_btn.on('click', $.proxy(this.onPrev, this));
		this.$next_btn.on('click', $.proxy(this.onNext, this));
	}

	addList(val) {
		this.set.add(val);
		this.update();
	}

	deleteList(val) {
		this.set.delete(val);
		this.update();
	}

	update() {
		let dom = '';

		this.set.forEach(v => {
			if (this.id === 'cc') {
				dom += `<li class="selected-slide__item"><span class="selected-delete" data-number="${v}"></span><p>${v}</p></li>`;
			} else {
				dom += `<li class="selected-slide__item"><span class="selected-delete" data-number="${v}"></span><img data-src="${v}" class="selected-img"></li>`;
			}
		});

		this.$list.empty();
		this.$list[0].insertAdjacentHTML('afterbegin', dom);

		// 横幅チェック
		this.$items = this.$root.find('.selected-slide__item');
		this.distance = this.$items.eq(0).outerWidth(true);
		this.items_width = 0;

		for (let i = 0, l = this.$items.length; i < l; i++) {
			this.items_width += this.$items.eq(i).outerWidth(true);
		}

		this.maxcount = Math.ceil((this.items_width - this.$list.width()) / this.distance);
		if (this.maxcount < 0) this.maxcount = 0;

		this.onResize();
	}

	onResize() {
		this.navToggle(this.items_width > this.$list.width());
	}

	navToggle(show) {
		if (show) {
			if (this.count > this.maxcount) {
				this.count = this.maxcount;
				this.$next_btn.hide();
				this.onMove();
			} else {
				this.$next_btn.show();
			}
		} else {
			tm.set(this.$list, { x: 0 });
			this.count = 0;

			this.$root.removeClass('selected-area--moved');
			this.$prev_btn.hide();
			this.$next_btn.hide();
		}
	}

	onTouch(e) {
		const x = e.originalEvent.changedTouches[0].pageX;

		if (e.type === 'touchstart') {
			this.touches.startX = x;
			this.touches.currentX = this.$list[0]._gsTransform.x;
		} else if (e.type === 'touchmove') {
			this.touches.moveX = x - this.touches.startX;

			const mx = this.touches.currentX + this.touches.moveX;

			this.touches.endX = mx;

			tm.set(this.$list, { x: mx });
		} else {
			if (Math.abs(this.touches.moveX) <= 20) {
				this.touches = { startX: 0, moveX: 0, endX: 0, currentX: 0 };
				this.onMove();
				return;
			}

			if (this.touches.moveX > 0) {
				this.count = Math.floor(this.touches.endX / -this.distance);
			} else {
				this.count = Math.ceil(this.touches.endX / -this.distance);
			}

			if (this.count <= 0) this.count = 0;
			if (this.count >= this.maxcount) this.count = this.maxcount;

			this.touches = { startX: 0, moveX: 0, endX: 0, currentX: 0 };
			this.onMove();
		}
	}

	onPrev() {
		this.count -= 1;
		this.onMove();
	}

	onNext() {
		this.count += 1;
		this.onMove();
	}

	onMove() {
		this.$prev_btn.show();
		this.$next_btn.show();
		if (this.count <= 0) {
			this.$prev_btn.hide();
			this.count = 0;
		}
		if (this.count >= this.maxcount) {
			this.$next_btn.hide();
			this.count = this.maxcount;
		}

		this.$root.addClass('selected-area--moved');
		if (this.count === 0) this.$root.removeClass('selected-area--moved');

		tm.to(this.$list, 0.4, {
			x: -this.distance * this.count
		});
	}

	getSetData() {
		let result = [];

		this.set.forEach(v => result.push(v));

		return result;
	}

	getDom() {
		return this.$items;
	}
}

export default Slide;



// WEBPACK FOOTER //
// ./src/js/app/Slide.js